import AccountBalanceWalletOutlined from "@mui/icons-material/AccountBalanceWalletOutlined";
import ConstructionOutlined from "@mui/icons-material/ConstructionOutlined";
import CreditCardOutlined from "@mui/icons-material/CreditCardOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import HelpOutlineRounded from "@mui/icons-material/HelpOutlineRounded";
import HomeRounded from "@mui/icons-material/HomeRounded";
import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import ShoppingCartOutlined from "@mui/icons-material/ShoppingCartOutlined";
import UploadFileOutlined from "@mui/icons-material/UploadFileOutlined";

export const navItems = [
  { key: "visao-geral", label: "Visão Geral", to: "/agentecontabilidade/visao-geral", icon: HomeRounded },
  { key: "dre", label: "DRE Viabilidade", to: "/agentecontabilidade/dre-viabilidade", icon: DescriptionOutlined },
  { key: "vendas", label: "Receita de Vendas", to: "/agentecontabilidade/vendas", icon: ShoppingCartOutlined },
  { key: "recebiveis", label: "Carteira de Recebíveis", to: "/agentecontabilidade/carteira-recebiveis", icon: AccountBalanceWalletOutlined },
  { key: "custos", label: "Custo do Empreendimento", to: "/agentecontabilidade/custos", icon: ConstructionOutlined },
  { key: "impostos", label: "Gestão de Imposto", to: "/agentecontabilidade/impostos", icon: ReceiptLongOutlined },
  { key: "despesas", label: "Gestão de Despesas", to: "/agentecontabilidade/despesas", icon: CreditCardOutlined },
  { key: "importacao", label: "Importação de Dados", to: "/agentecontabilidade/importacao", icon: UploadFileOutlined },
  { key: "ajuda", label: "Central de Ajuda", to: "/agentecontabilidade/ajuda", icon: HelpOutlineRounded },
];

export const agenteSuggestions = [
  "Qual a saúde financeira do empreendimento?",
  "A margem está melhorando ou piorando?",
  "O sócio está financiando a obra?",
];
